import client from '../httpClient';

const allocationSettingCsvUploadApi = (formData) => {
  const headers = { 'content-type': 'multipart/form-data' };
  return client.post('/allocation-settings/csv-upload/', formData, { headers });
};

export default allocationSettingCsvUploadApi;
